<template>
<v-layout @copy.prevent="" @contextmenu.prevent="" row justify-center>
  <v-flex class="px-2 pb-3" xs12 sm10>
    <v-card flat>
      <v-layout row wrap justify-center>
        <v-flex class="pb-4 pt-3" xs12>
          <v-card class="pa-2" flat>
            <v-layout row>
              <v-flex class="pr-2" xs1>
                <div class="headline text-xs-right">1.</div>
              </v-flex>
              <v-flex class="pl-2 text-xs-left" xs>
                <div class="headline">{{questionData.body}}</div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex v-if="questionData.type == 'Matching/Dropdown'" class="pb-3" xs10>
          <v-card
            v-for="answer,i in choice"
            :key="i"
            class="pa-3 mb-3"
            color="grey lighten-4"
          >
            <v-layout row wrap>
              <v-flex class="pr-2 pt-3" xs1>
                <div class="title pt-1">{{answer.letter}}.</div>
              </v-flex>
              <v-flex class="pl-2 pt-3 text-xs-left" xs11 sm5>
                <div class="title pt-1">{{answer.text}}</div>
              </v-flex>
              <v-flex class="pl-2 pt-2 text-xs-left" xs12 sm6>
                <v-select
                  label="Answer"
                  v-model="answer.selected"
                  :items="options"
                  hide-details
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex v-else class="pb-3" xs10>
          <v-card
            @click.native="chooseAnswer(i)"
            style="cursor: pointer"
            v-for="answer,i in choice"
            :key="i"
            class="pa-3 mb-3"
            :color="answer.selected ? 'primary white--text' : 'grey lighten-4'"
          >
            <v-layout row wrap>
              <v-flex class="pr-2" xs1>
                <div class="title pt-1">{{answer.letter}}.</div>
              </v-flex>
              <v-flex class="pl-2 text-xs-left" xs11>
                <div class="title pt-1">{{answer.text}}</div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex v-if="graded" class="title text-xs-center pb-3" xs12>
          <div :class="(points == possible) ? 'success--text' : 'error--text'">
            <b>{{(points == possible) ? 'Correct!' : 'Wrong..'}}</b>
          </div>
          <div class="title pt-3"><b>Rationale</b><br>{{questionData.rationale == '' ? 'No Rationale' : questionData.rationale}}</div>
        </v-flex>
        <v-flex class="text-xs-center" xs12>
          <v-btn v-if="!graded" @click.native="grade" color="success" depressed large>Submit</v-btn>
          <v-btn v-else @click.native="resetChoice" color="error" flat large><b>Reset</b></v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  props: ['questionData'],
  data: () => ({
    choice: [],
    options: [],
    toggle: 1,
    graded: false,
    possible: 0,
    points: 0
  }),
  beforeMount () {
    this.resetChoice()
  },
  methods: {
    resetChoice () {
      this.choice = []
      this.options = []
      if (this.questionData.type === 'Matching/Dropdown') {
        for (let a of this.questionData.answers) {
          this.choice.push({...a, selected: ''})
          this.options.push(a.correct)
        }
        this.scramble()
      } else {
        for (let a of this.questionData.answers) {
          this.choice.push({...a, selected: false})
        }
      }
      this.graded = false
      this.possible = 0
      this.points = 0
    },
    scramble () {
      let newIndices = []
      let newOptions = []
      let num = null
      while (newIndices.length < this.options.length) {
        num = this.$store.getters.rng(0, this.options.length)
        if (!newIndices.includes(num)) newIndices.push(num)
      }
      for (let n of newIndices) {
        newOptions.push(this.options[n])
      }
      this.options = [...newOptions]
    },
    chooseAnswer (index) {
      if (!this.graded) {
        if (this.questionData.type === 'Matching/Dropdown') return false
        else if (this.questionData.type === 'Select All That Apply') {
          for (let i = 0; i < this.choice.length; i++) {
            if (i === index) this.choice[i].selected = !this.choice[i].selected
          }
        } else {
          for (let i = 0; i < this.choice.length; i++) {
            if (i === index) this.choice[i].selected = true
            else this.choice[i].selected = false
          }
        }
      }
    },
    setPartial () {
      this.partial = true
      this.toggle = this.partial ? 0 : 1
    },
    noPartial () {
      this.partial = false
      this.toggle = this.partial ? 0 : 1
    },
    grade () {
      for (let i = 0; i < this.choice.length; i++) {
        this.possible += 1
        this.points += (this.choice[i].correct === this.choice[i].selected) ? 1 : 0
      }
      this.graded = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/QuestionPreview.vue